import { Clock, LogOut, Mail } from 'lucide-react'
import { useAuth } from '@/contexts/AuthContext'

export default function AccessExpired() {
  const { profile, signOut } = useAuth()

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="flex justify-center">
          <div className="w-20 h-20 rounded-full bg-orange-100 flex items-center justify-center">
            <Clock className="w-10 h-10 text-orange-500" />
          </div>
        </div>

        <div>
          <h1 className="text-2xl font-bold">Acceso expirado</h1>
          <p className="text-muted-foreground mt-2">
            Hola {profile?.first_name}, tu acceso a la plataforma ha expirado.
            Ha pasado más de un mes desde tu último examen.
          </p>
        </div>

        <div className="bg-card border rounded-xl p-5 space-y-2 text-sm text-muted-foreground text-left">
          <p className="font-medium text-foreground">¿Quieres retomar el curso?</p>
          <p>Contáctanos para consultar tus opciones de reincorporación:</p>
          <a
            href="mailto:cfi.nomadlexis@gmail.com"
            className="inline-flex items-center gap-2 text-primary font-medium hover:underline"
          >
            <Mail className="w-4 h-4" />
            cfi.nomadlexis@gmail.com
          </a>
        </div>

        <button
          onClick={signOut}
          className="inline-flex items-center gap-2 px-4 py-2 text-sm text-muted-foreground hover:bg-muted rounded-lg transition-colors"
        >
          <LogOut className="w-4 h-4" />
          Cerrar sesión
        </button>
      </div>
    </div>
  )
}
